"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useState, useContext, ReactNode } from "react";
import { useAtom } from "jotai";
import { viewLayoutAtom, viewMapSize, viewShowMapAtom } from "./View.jotai";
import { useMobile } from "@/components/providers/MobileProvider";
import { ViewMode } from "@/constants/viewMode";
export const SMALL_SIZE_CONTAINER = 5;
export const BIG_SIZE_CONTAINER = 6;
export const MAX_SIZE_CONTAINER = SMALL_SIZE_CONTAINER + BIG_SIZE_CONTAINER;
export const MIN_SIZE_CONTAINER = 0;
export const MAP_ANIMATION_TIME = 300;
interface ViewContextProps {
  handleToggleExpandMap: () => void;
  handleShowMap: () => void;
  handleHideMap: () => void;
  handleSwitchMap: () => void;
  leftWidth: number;
  rightWidth: number;
  mapKey: number;
  colsSize: number[];
  showMap: boolean;
  mapSize: "small-size" | "max-size";
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}
const ViewContext = createContext<ViewContextProps | undefined>(undefined);
export const ViewProvider = t0 => {
  const $ = _c(31);
  const {
    children
  } = t0;
  const isMobile = useMobile();
  const [mapKey] = useState(0);
  const [showMap, setShowMap] = useAtom(viewShowMapAtom);
  const [mapSize, setMapSize] = useAtom(viewMapSize);
  const [viewMode, setViewMode] = useAtom(viewLayoutAtom);
  let t1;
  if ($[0] !== isMobile || $[1] !== mapSize || $[2] !== showMap) {
    t1 = isMobile ? showMap ? [MIN_SIZE_CONTAINER, MAX_SIZE_CONTAINER] : [MAX_SIZE_CONTAINER, MIN_SIZE_CONTAINER] : showMap ? mapSize === "max-size" ? [MIN_SIZE_CONTAINER, MAX_SIZE_CONTAINER] : [SMALL_SIZE_CONTAINER, BIG_SIZE_CONTAINER] : [MAX_SIZE_CONTAINER, MIN_SIZE_CONTAINER];
    $[0] = isMobile;
    $[1] = mapSize;
    $[2] = showMap;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const colsSize = t1;
  const totalFlex = colsSize[0] + colsSize[1];
  const leftWidth = colsSize[0] / totalFlex * 100;
  const rightWidth = colsSize[1] / totalFlex * 100;
  let t2;
  if ($[4] !== mapSize || $[5] !== setMapSize) {
    t2 = () => {
      if (mapSize === "max-size") {
        setMapSize("small-size");
      } else {
        setMapSize("max-size");
      }
    };
    $[4] = mapSize;
    $[5] = setMapSize;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleToggleExpandMap = t2;
  let t3;
  if ($[7] !== setShowMap) {
    t3 = () => {
      setShowMap(true);
    };
    $[7] = setShowMap;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleShowMap = t3;
  let t4;
  if ($[9] !== setShowMap) {
    t4 = () => {
      setShowMap(false);
    };
    $[9] = setShowMap;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleHideMap = t4;
  let t5;
  if ($[11] !== handleHideMap || $[12] !== handleShowMap || $[13] !== showMap) {
    t5 = () => {
      if (showMap) {
        handleHideMap();
      } else {
        handleShowMap();
      }
    };
    $[11] = handleHideMap;
    $[12] = handleShowMap;
    $[13] = showMap;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleSwitchMap = t5;
  let t6;
  if ($[15] !== colsSize || $[16] !== handleHideMap || $[17] !== handleShowMap || $[18] !== handleSwitchMap || $[19] !== handleToggleExpandMap || $[20] !== leftWidth || $[21] !== mapKey || $[22] !== mapSize || $[23] !== rightWidth || $[24] !== setViewMode || $[25] !== showMap || $[26] !== viewMode) {
    t6 = {
      handleShowMap,
      handleHideMap,
      handleSwitchMap,
      handleToggleExpandMap,
      leftWidth,
      rightWidth,
      mapKey,
      showMap,
      colsSize,
      mapSize,
      viewMode,
      setViewMode
    };
    $[15] = colsSize;
    $[16] = handleHideMap;
    $[17] = handleShowMap;
    $[18] = handleSwitchMap;
    $[19] = handleToggleExpandMap;
    $[20] = leftWidth;
    $[21] = mapKey;
    $[22] = mapSize;
    $[23] = rightWidth;
    $[24] = setViewMode;
    $[25] = showMap;
    $[26] = viewMode;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== children || $[29] !== t6) {
    t7 = <ViewContext.Provider value={t6} data-sentry-element="ViewContext.Provider" data-sentry-component="ViewProvider" data-sentry-source-file="ViewProvider.tsx">{children}</ViewContext.Provider>;
    $[28] = children;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
};
export const useView = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error("useView must be used within a ViewProvider");
  }
  return context;
};